import { useSessionStorage } from './useSessionStorage';

export function useViewMode() {
  const [inAdminView, setInAdminView] = useSessionStorage<boolean>('inAdminView', false);

  const toggleAdminView = () => {
    setInAdminView(prev => !prev);
  };

  const disableAdminView = () => {
    setInAdminView(false);
  };

  return { inAdminView, disableAdminView, toggleAdminView };
}
